import dayjs from "dayjs";
import formatPlugin from "dayjs/plugin/localizedFormat";
import sameOrBeforePlugin from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import preParsePostFormat from 'dayjs/plugin/preParsePostFormat'
import ar from 'dayjs/locale/ar'

export function getExactDate(date: string, format: string = "llll", locale?: string) {
  dayjs.extend(formatPlugin);
  dayjs.extend(preParsePostFormat)

  if (locale) dayjs.locale(locale);
  return dayjs(date).format(format);
}

export function isSameOrBeforeNow(date: string) {
  dayjs.extend(sameOrBeforePlugin);

  return dayjs(date).isSameOrBefore(dayjs(), "day");
}

export function convertToTimezone(date: string, format?: string, locale?: string) {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(preParsePostFormat)

  const zone = dayjs.tz.guess();
  return dayjs
    .utc(date)
    .tz(zone)
    .locale(locale?.startsWith('ar-')? ar : "en")
    .format(format ? format : "DD/MM/YYYY hh:mm a");
}

export function formatDateTimeLocal(date: Date | string | null): string | undefined {
  if (!date) return undefined;

  // Create dayjs instance from the date, which will be in user's local timezone
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
}
